import { Button } from "antd";
import styles from "./LoginWithAzureSSO.module.less";
import { MICROSOFT_ICON_PATH } from "../../constants/path";
import { useLanguage } from "~/hooks/useLanguage";
import { useLoginWithAzure } from "./hooks/useLoginWithAzure";
const LoginWithAzureSSO = () => {
  const { loading, handleLoginWithAzure } = useLoginWithAzure();
  const { formatMessage } = useLanguage();

  return (
    <div className={styles.ssoLoginContainer}>
      <span>{formatMessage("Login.Label.SignInWith")}</span>
      <Button
        id="azureSSOButton"
        size="large"
        className={styles.ssoLoginButton}
        type="default"
        block
        loading={loading}
        onClick={handleLoginWithAzure}
      >
        <img src={MICROSOFT_ICON_PATH} />
        {formatMessage("Login.Label.LoginWithAzureSSO")}
      </Button>
    </div>
  );
};

export default LoginWithAzureSSO;
